"use client";

import { FaArrowRight } from "react-icons/fa";

interface ApplyButtonProps {
	googleFormUrl: string;
	className?: string;
}

export const ApplyButton = ({
	googleFormUrl,
	className = "",
}: ApplyButtonProps) => {
	const handleClick = (): void => {
		window.open(googleFormUrl, "_blank", "noopener,noreferrer");
	};

	return (
		<div>
			<button
				type="button"
				onClick={handleClick}
				className={`
        relative
        transition-all 
        duration-300 
        ease-in-out
        transform 
        hover:scale-105
        ${className}
      `}
			>
				{/* 紫の楕円（背景） */}
				<div
					className="
        bg-suzuka2025darkPurple 
        hover:bg-suzuka2025purple 
        rounded-full 
        px-2
        py-2
        shadow-lg 
        hover:shadow-xl
        transition-all 
        duration-300
        min-w-[280px]
        md:min-w-[320px]
        h-16
        md:h-20
      "
				>
					{/* 白の楕円（前面） */}
					<div
						className="
          bg-white 
          rounded-full 
          flex 
          items-center 
          relative
          px-6 
          py-3
          h-full
          shadow-md
        "
					>
						{/* 矢印アイコン（左側固定） */}
						<div className="flex items-center justify-center w-10 h-10 bg-suzuka2025purple rounded-full absolute left-3">
							{FaArrowRight({ className: "text-white text-sm w-6 h-6" })}
						</div>
						{/* テキスト（残りの部分の中央） */}
						<div className="flex-1 flex items-center justify-center ml-10">
							<span
								className="
              text-suzuka2025purple 
              font-bold 
              text-xl 
              md:text-2xl
              font-zenMaru
            "
							>
								応募する
							</span>
						</div>
					</div>
				</div>
			</button>
			<p className="text-white text-center font-bold">
				応募〆切：12月7日（日）
			</p>
		</div>
	);
};
